import type { MailContentProps, MailMetadata } from "../../lib/types";
import { MailSignature } from "../mail/mail-signature";

function HorairesDeMonsieurMurat({ variablesData }: MailContentProps) {
  return (
    <div className="space-y-2">
      <p>
        Bonjour {variablesData.genre_masc_abrege}{" "}
        {variablesData.responsable_grand_est_precedent_nom},
      </p>
      <p>
        Je me dois de vous informer de mon insatisfaction concernant{" "}
        {variablesData.genre_masc_complet}{" "}
        {variablesData.employe_service_du_personnel_nom} ( employé du service du
        personnel) dont les horaires de présence sont pour le moins
        fantaisistes.
      </p>
      <p>
        Déterminer avec exactitude ses heures d'arrivée et de départ relève de
        l'exploit. A plusieurs reprises, j'ai signifié fermement à{" "}
        {variablesData.genre_masc_complet}{" "}
        {variablesData.employe_service_du_personnel_nom} ma désapprobation au
        sujet de ce problème, mais celui-ci me réplique invariablement que son
        travail étant toujours effectué dans les délais prévus (ce qui s'observe
        effectivement dans le cadre de ses entretiens d'appréciation), il ne
        voit aucune raison de modifier son comportement. Il est vrai que{" "}
        {variablesData.genre_masc_complet}{" "}
        {variablesData.employe_service_du_personnel_nom} est jeune et fait
        partie de cette génération dite « génération Z » !
      </p>
      <p>
        Pourriez-vous résoudre ce problème et faire entendre raison à{" "}
        {variablesData.genre_masc_complet}{" "}
        {variablesData.employe_service_du_personnel_nom} ?
      </p>
      <p>Cordialement,</p>
      <MailSignature
        emetteurLogo={HorairesDeMonsieurMurat.metadata.emetteurLogo}
        emetteur={HorairesDeMonsieurMurat.metadata.emetteur}
        emetteurPoste={HorairesDeMonsieurMurat.metadata.emetteurPoste}
        emetteurEntreprise={HorairesDeMonsieurMurat.metadata.emetteurEntreprise}
      />
    </div>
  );
}

HorairesDeMonsieurMurat.metadata = {
  titre: "Horaires de Monsieur MURAT",
  cleMail: "horaires_monsieur_murat",
  messageTransfert: false,
  emetteur: "François AS",
  emetteurPoste: "Responsable Asministratif",
  emetteurEntreprise: "SYTEL Grand Est",
  emetteurLogo: "/logos/sytel_grand_est.png",
  dateRelative: -8,
  piecesJointes: [],
} as MailMetadata;

export default HorairesDeMonsieurMurat;
